import Cookies from 'js-cookie'
import { EventBus, Events } from '@/eventbus/EventBus'
import { UPLOAD_COOKIE } from '@/stores/store'

export const CONSENT_COOKIE = 'COOKIE_CONSENT'
const CONSENT_DENIED = 'denied'
const CONSENT_ALLOWED = 'allowed'
const RIJNJA_COOKIES = ['PHPSESSID', UPLOAD_COOKIE, CONSENT_COOKIE]

function removeThirdPartyCookies() {
  const cookieNames = document.cookie.split(';').map((cookie) => {
    return cookie.split('=')[0].trim()
  })
  cookieNames.forEach((name) => {
    if (!RIJNJA_COOKIES.includes(name)) {
      Cookies.remove(name)
    }
  })
}

export const hasConsentCookie = () => {
  return Cookies.get(CONSENT_COOKIE)
}

export const cookiesAllowed = () => {
  return Cookies.get(CONSENT_COOKIE) === CONSENT_ALLOWED
}

export const allowCookies = () => {
  Cookies.set(CONSENT_COOKIE, CONSENT_ALLOWED, {
    expires: 90,
    sameSite: 'strict',
    secure: true
  })
  EventBus.emit(Events.ENABLE_GTM, true)
}

export const denyCookies = () => {
  Cookies.set(CONSENT_COOKIE, CONSENT_DENIED, {
    expires: 90,
    sameSite: 'strict',
    secure: true
  })
  EventBus.emit(Events.ENABLE_GTM, false)
  removeThirdPartyCookies()
}

export const currentCookieConsentSetting = () => {
  return Cookies.get(CONSENT_COOKIE) === CONSENT_ALLOWED
    ? 'TOEGESTAAN'
    : 'GEWEIGERD'
}
